import { render, staticRenderFns } from "./frontend_webunit.vue?vue&type=template&id=5ca44d34"
import script from "./frontend_webunit.vue?vue&type=script&lang=js"
export * from "./frontend_webunit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports